<template>
  <section v-if="regionInfo?.banner?.length" class="banner mt-5 md:my-0">
    <carousel
      ref="carouselRef"
      autoplay
      navigator
      :title="regionInfo?.web_greetings"
      title-class="text-base font-400 hidden md:block md:text-base md:my-6 md:py-1"
      swiper-slide-class="first:ml-0 last:mr-0"
      :data="regionInfo.banner"
      :swiper-options="swiperOptions"
    >
      <template #default="{ item, index }">
        <home-banner-item :item="item" :index="index" @click="handleBannerClick(item)" />
      </template>
      <template #skeleton>
        <div class="flex gap-2 md:gap-5 md:overflow-hidden">
          <home-banner-item
            v-for="item in regionInfo.banner.slice(0, appStore.isMobileScreen ? 1 : 4)"
            :key="item.id"
            :item="item"
            class="flex-none"
          />
        </div>
      </template>
    </carousel>
  </section>
</template>

<script lang="ts" setup>
import type { SwiperOptions } from 'swiper/types'

import Carousel from '@/components/common/carousel.vue'
import HomeBannerItem from '@/components/home/home-banner-item.vue'
import { GtmEvent } from '@/types/gtm'

import { useAppStore } from '@/store/app'
import { useRegionStore } from '@/store/region'

import type { CarouselExposed } from '@/types/component'
import type { RegionBanner } from '@/types/api'

const nuxtApp = useNuxtApp()

const appStore = useAppStore()
const regionStore = useRegionStore()

const { regionInfo } = storeToRefs(regionStore)

const carouselRef = ref<Nullable<CarouselExposed>>(null)

const swiper = computed(() => carouselRef.value?.swiper)
const swiperOptions = computed<SwiperOptions>(() => ({
  freeMode: false,
  cssMode: false,
  centeredSlides: appStore.isMobileScreen,
}))

function handleBannerClick(item: RegionBanner) {
  const payload = {
    'Banner ID': item.id,
    'Banner Title': item.title,
    Path: item.link_target,
    Sequence: swiper.value?.clickedIndex,
  }
  nuxtApp.$trackEvent({
    event: GtmEvent.BANNER_CLICKED,
    payload,
  })
}
</script>
